<div [id]="getId()" class="modal quicklink-modal access-code-modal" data-backdrop="static"
     data-keyboard="false"
     role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                @if (applicationStateService.userData.isTeacher) {
                    <h2>Wählen Sie einen Stickercode für diese Sitzung</h2>
                    <p>Sie besitzen mehrere aktive Stickercodes für dieses Werk.<br/>Bitte wählen Sie einen aus, um bei
                        externen Anbietern Ihre Daten zu speichern</p>
                }
                @if (!applicationStateService.userData.isTeacher) {
                    <h2>Wähle deinen Stickercode für diese Sitzung</h2>
                    <p>Du hast mehrere aktive Stickercodes für dieses Buch.<br/>Bitte wähle einen aus, um mit deinem
                        bisherigen Fortschritt fortzufahren.</p>
                }

                @for (code of applicationStateService.userData.accessCodes; track code; let isFirst = $first) {
                    <button (click)="selectCode(code)"
                       [ngClass]="{'is-plus': accessService.isPlus(code.version)}"
                       class="code-link"
                    >
                        <img [attr.alt]="code.resourceName" [attr.src]="code.cover" style="width: 60px"/>
                        <span class="text-wrapper">
                          <span class="resource-name">{{ code.resourceName }}</span>
                          <span class="code">Stickercode: <strong>{{ code.code }}</strong></span>
                            @if (accessService.isPlus(code.version)) {
                                <span class="code">Ebook Plus: <strong>Ja</strong></span>
                            } @else if (accessService.isBasic(code.version)) {
                                <span class="code">Ebook Basis: <strong>Ja</strong></span>
                            }
                          @if (isFirst) {
                            <strong class="used"><i>Zuletzt genutzt/aktiviert</i></strong>
                          }
                        </span>
                    </button>
                }
            </div>
        </div>
    </div>
</div>
